export enum MediaType {
  Image,
  Video,
  FreeText
}